import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import emptyMessageModal from 'src/assets/icons/empty_message_modal.jpg'
import Button from 'src/components/common/Button'
import { DOWNLOAD_APP_LINK } from 'src/constants'
import { CloseOutlined } from '@ant-design/icons'
import PropTypes from 'prop-types'

import styles from './chat-panel.scss'

const ChatPanel = ({ onClose }) => {
  const userId = useSelector(state => state.userId)

  useEffect(() => {
    window.mixpanel.track('Chat Clicked', { user_id: userId })
  }, [])

  return (
    <div className={styles['menu-panel']}>
      <h3 className={styles['title']}>Chat</h3>
      <CloseOutlined className={styles['close-icon']} onClick={onClose} />
      <div className={styles['content']}>
        <div className={styles['download-app']}>
          <img src={emptyMessageModal} />
          <div className={styles['description']}>
            <h3>To Chat, Get the App</h3>
            <div>
              Hobnob makes group chats pain-free and private! Download Hobnob to direct message any
              guest on the guest list.
            </div>
          </div>
          <Button
            wrapperElement={'a'}
            href={DOWNLOAD_APP_LINK}
            target="_blank"
            className={styles['button']}
            onClick={() => window.mixpanel.track('GET HOBNOB TO CHAT Clicked', { user_id: userId })}
          >
            <span>Get hobnob to chat</span>
          </Button>
        </div>
      </div>
    </div>
  )
}

ChatPanel.propTypes = {
  onClose: PropTypes.func.isRequired
}

export default ChatPanel
